import { render } from "./VideoEmbed.vue?vue&type=template&id=573ed85c&scoped=true&ts=true"
import script from "./VideoEmbed.vue?vue&type=script&lang=ts"
export * from "./VideoEmbed.vue?vue&type=script&lang=ts"

import "./VideoEmbed.vue?vue&type=style&index=0&id=573ed85c&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573ed85c"]])

export default __exports__